export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,
  title: '代储出版社版数控制',
} as TCommon.RouteConfig
